<script >
export default {
  name: 'Bafylc',
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<template>
  <div class="container">
    <section class="guide-section">
      <h2 class="title">1.出院病案复印流程</h2>
      <div class="code-diagram discharge-diagram" aria-label="出院病案复印流程">
        <div class="diagram-node discharge-start">患者出院十个工作日后</div>
        <div class="diagram-node discharge-branch">
          携带相关材料至门<br>诊一站式服务<br>台
        </div>
        <div class="diagram-node diamond-node discharge-contact">
          <span>电话联系病案管理部<br>0512-65792473</span>
        </div>
        <div class="diagram-node round-node discharge-check">
          病案管理部核对患者信息，查询所需复印<br>病案内容，复印后加盖公章
        </div>
        <div class="diagram-node discharge-pay">申请人到门诊收费处或线上缴费</div>
        <div class="diagram-node round-node discharge-submit">
          申请人携带缴费单据及相关材料，到门诊<br>三楼病案管理部
        </div>
        <div class="diagram-node discharge-verify">
          病案管理部工作人员当面核对证明材料，<br>并留存登记
        </div>
        <div class="diagram-node round-node discharge-receive">
          申请人签字确认后领取病案复印件
        </div>

        <i class="diagram-line line-start-contact line-down" aria-hidden="true" />
        <i class="diagram-line line-start-branch line-left" aria-hidden="true" />
        <i class="diagram-line line-branch-contact line-elbow-right" aria-hidden="true" />
        <i class="diagram-line line-contact-check line-down" aria-hidden="true" />
        <i class="diagram-line line-check-pay line-down" aria-hidden="true" />
        <i class="diagram-line line-pay-submit line-down" aria-hidden="true" />
        <i class="diagram-line line-submit-verify line-down" aria-hidden="true" />
        <i class="diagram-line line-verify-receive line-down" aria-hidden="true" />

        <div class="material-panel discharge-materials">
          <h3>相关材料内容:</h3>
          <ol>
            <li>申请人为患者本人的，应当提供其有效身份证明</li>
            <li>申请人为患者代理人的，应当提供患者及其代理人的有效身份证明，以及代理人与患者代理关系的法定证明材料和患者本人的授权委托书;</li>
            <li>申请人为死亡患者法定继承人的，应当提供患者死亡证明、死亡患者法定继承人的有效身份证明，死亡患者与法定继承人关系的法定证明材料;</li>
            <li>申请人为死亡患者法定继承人代理人的，应当提供患者死亡证明、死亡患者法定继承人及其代理人的有效身份证明，死亡患者与法定继承人关系的法定证明材料，代理人与法定继承人代理关系的法定证明材料及授权委托书;</li>
            <li>公安、司法机关、保险机构因办理案件，需要查阅、复印或者复制病历资料的，应当出具采集证据的法定证明(介绍信，调查令等)及执行公务人员的有效身份证明。</li>
          </ol>
        </div>
      </div>
      <p class="tip">
        出院病案复印服务时间:工作日上午8:00-11:30 下午 13:30-17:00 <br>(不包括周末及法定节假日)
      </p>
    </section>

    <section class="guide-section outpatient-section">
      <h2 class="title">2.门(急)诊病案复印流程</h2>
      <div class="code-diagram outpatient-diagram" aria-label="门急诊病案复印流程">
        <div class="diagram-node round-node outpatient-applicant">患者或相关申请人</div>
        <div class="diagram-node round-node outpatient-proof">携带证明材料</div>
        <div class="diagram-node outpatient-service">
          门诊一站式服务台缴费、办理<br>0512-65331356
        </div>

        <i class="diagram-line line-applicant-proof line-down" aria-hidden="true" />
        <i class="diagram-line line-proof-service line-down" aria-hidden="true" />

        <div class="material-panel outpatient-materials">
          <h3>相关材料内容:</h3>
          <ol>
            <li>申请人为患者本人的，应当提供其有效身份证明</li>
            <li>申请人为患者代理人的，应当提供患者及其代理人的有效身份证明，以及代理人与患者代理关系的法定证明材料和患者本人的授权委托书;</li>
            <li>申请人为死亡患者法定继承人的，应当提供患者死亡证明、死亡患者法定继承人的有效身份证明，死亡患者与法定继承人关系的法定证明材料;</li>
            <li>申请人为死亡患者法定继承人代理人的，应当提供患者死亡证明、死亡患者法定继承人及其代理人的有效身份证明，死亡患者与法定继承人关系的法定证明材料，代理人与法定继承人代理关系的法定证明材料及授权委托书;</li>
            <li>公安、司法机关、保险机构因办理案件，需要查阅、复印或者复制病历资料的，应当出具采集证据的法定证明(介绍信，调查令等)及执行公务人员的有效身份证明。</li>
          </ol>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped lang="less">
.container{
  background: #fff;
  padding: 0 12px;
  color: #333;
  overflow: hidden;
  .guide-section {
    padding-top: 25px;
  }
  .title{
    margin: 0 0 20px;
    font-size: 0.18rem;
    font-weight: bold;
    text-align: center;
    letter-spacing: 1px;
  }
  .tip{
    font-size: 13px;
    color: #333;
    text-align: center;
    line-height: 1.5;
    margin: 24px 0 15vw;
    letter-spacing: 0.5px;
  }
}

.code-diagram {
  --diagram-blue: #58afe5;
  --diagram-fill: #e1eef9;
  --diagram-stroke: calc((100vw - 24px) * 0.004);
  position: relative;
  width: 100%;
  margin: 0 auto;
  color: #333;
}

.discharge-diagram {
  max-width: 981px;
  aspect-ratio: 981 / 2580;
  font-size: calc((100vw - 24px) * 0.029);
}

.outpatient-diagram {
  max-width: 1065px;
  aspect-ratio: 1065 / 1135;
  font-size: calc((100vw - 24px) * 0.026);
}

.diagram-node {
  box-sizing: border-box;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border: var(--diagram-stroke) solid var(--diagram-blue);
  background: var(--diagram-fill);
  line-height: 1.55;
  text-align: center;
}

.round-node {
  border-radius: 0.6em;
}

.diamond-node {
  border: 0;
  background: var(--diagram-blue);
  clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
}

.diamond-node::before {
  position: absolute;
  top: var(--diagram-stroke);
  right: var(--diagram-stroke);
  bottom: var(--diagram-stroke);
  left: var(--diagram-stroke);
  background: var(--diagram-fill);
  clip-path: inherit;
  content: '';
}

.diamond-node span {
  position: relative;
  z-index: 1;
}

.diagram-line {
  box-sizing: border-box;
  position: absolute;
  z-index: 2;
  display: block;
  background: var(--diagram-blue);
}

.line-down {
  width: var(--diagram-stroke);
}

.line-down::after {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 0;
  border-top: calc(var(--diagram-stroke) * 3) solid var(--diagram-blue);
  border-right: calc(var(--diagram-stroke) * 1.8) solid transparent;
  border-left: calc(var(--diagram-stroke) * 1.8) solid transparent;
  content: '';
  transform: translateX(-50%);
}

.line-left {
  height: var(--diagram-stroke);
}

.line-left::after {
  position: absolute;
  top: 50%;
  left: 0;
  width: 0;
  height: 0;
  border-top: calc(var(--diagram-stroke) * 1.8) solid transparent;
  border-right: calc(var(--diagram-stroke) * 3) solid var(--diagram-blue);
  border-bottom: calc(var(--diagram-stroke) * 1.8) solid transparent;
  content: '';
  transform: translate(-90%, -50%);
}

.line-elbow-right {
  border-bottom: var(--diagram-stroke) solid var(--diagram-blue);
  border-left: var(--diagram-stroke) solid var(--diagram-blue);
  background: transparent;
}

.line-elbow-right::after {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 0;
  height: 0;
  border-top: calc(var(--diagram-stroke) * 1.8) solid transparent;
  border-bottom: calc(var(--diagram-stroke) * 1.8) solid transparent;
  border-left: calc(var(--diagram-stroke) * 3) solid var(--diagram-blue);
  content: '';
  transform: translate(90%, 50%);
}

.material-panel {
  box-sizing: border-box;
  position: absolute;
  overflow: hidden;
  border: var(--diagram-stroke) dashed var(--diagram-blue);
  background: var(--diagram-fill);
  line-height: 1.8;
}

.material-panel h3 {
  margin: 0;
  font-size: 1.05em;
  line-height: 1.7;
}

.material-panel ol {
  margin: 0;
  padding-left: 1.25em;
}

.material-panel li {
  padding-left: 0;
}

.discharge-start {
  top: 0.4%;
  left: 28.3%;
  width: 61.2%;
  height: 4%;
}

.discharge-branch {
  top: 4.65%;
  left: 0.45%;
  width: 25.2%;
  height: 7.75%;
  border-radius: 0.6em;
}

.discharge-contact {
  top: 11.8%;
  left: 19.2%;
  width: 80%;
  height: 7.75%;
}

.discharge-check {
  top: 22.1%;
  left: 28.3%;
  width: 61.2%;
  height: 5.75%;
}

.discharge-pay {
  top: 30.5%;
  left: 28.3%;
  width: 61.2%;
  height: 5.75%;
}

.discharge-submit {
  top: 38.9%;
  left: 28.3%;
  width: 61.2%;
  height: 5.75%;
}

.discharge-verify {
  top: 47.15%;
  left: 28.3%;
  width: 61.2%;
  height: 5.75%;
}

.discharge-receive {
  top: 55.4%;
  left: 28.3%;
  width: 61.2%;
  height: 5.75%;
}

.line-start-contact {
  top: 4.4%;
  left: 59%;
  height: 7.35%;
}

.line-start-branch {
  top: 8.45%;
  left: 25.7%;
  width: 33.4%;
}

.line-branch-contact {
  top: 12.4%;
  left: 12.9%;
  width: 6.25%;
  height: 3.25%;
}

.line-contact-check {
  top: 19.5%;
  left: 59%;
  height: 2.55%;
}

.line-check-pay {
  top: 27.85%;
  left: 59%;
  height: 2.6%;
}

.line-pay-submit {
  top: 36.25%;
  left: 59%;
  height: 2.6%;
}

.line-submit-verify {
  top: 44.65%;
  left: 59%;
  height: 2.45%;
}

.line-verify-receive {
  top: 52.9%;
  left: 59%;
  height: 2.45%;
}

.discharge-materials {
  top: 65.35%;
  left: 0.45%;
  width: 99%;
  height: 34.5%;
  padding: 3.2% 4.7%;
}

.outpatient-applicant {
  top: 0.45%;
  left: 0.4%;
  width: 40%;
  height: 13.5%;
}

.outpatient-proof {
  top: 34.8%;
  left: 0.4%;
  width: 40%;
  height: 13.5%;
  font-weight: bold;
}

.outpatient-service {
  top: 82.5%;
  left: 0.4%;
  width: 42.4%;
  height: 13.5%;
}

.line-applicant-proof {
  top: 13.95%;
  left: 20.4%;
  height: 20.75%;
}

.line-proof-service {
  top: 48.3%;
  left: 20.4%;
  height: 34.1%;
}

.outpatient-materials {
  top: 0.3%;
  left: 45.45%;
  width: 54.4%;
  height: 99.2%;
  padding: 1.8% 2.1%;
}

.outpatient-section {
  padding-bottom: 10vw;
}

@media (min-width: 1005px) {
  .discharge-diagram {
    --diagram-stroke: 4px;
    font-size: 28px;
  }
}

@media (min-width: 1089px) {
  .outpatient-diagram {
    --diagram-stroke: 4px;
    font-size: 28px;
  }
}
</style>
